import React from "react";
import { RaisedButton, Popover, Menu, MenuItem } from "material-ui";
import { PopoverAnimationVertical } from "material-ui/Popover";
import qs from "qs";

import TicketActions from "../../actions/TicketActions";

import config from "../../config";

class DownloadTicketsPdfButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: null
    };

    this._onClick = this._onClick.bind(this);
    this._onClose = this._onClose.bind(this);
    this.download = this.download.bind(this);
  }

  _onClick(e) {
    e.preventDefault();

    this.setState({
      open: true,
      anchorEl: e.currentTarget
    });
  }

  _onClose() {
    this.setState({ open: false });
  }

  download(forTicketPrinter) {
    TicketActions.downloadPdf({
      _id:
        this.props.tickets && this.props.tickets.length
          ? { $in: this.props.tickets }
          : undefined,
      person: this.props.order ? undefined : this.props.person,
      order: this.props.order,
      event_bucket: this.props.eventBucket,
      for_ticket_printer: forTicketPrinter ? true : undefined
    });
  }

  render() {
    let { style, label } = this.props;

    return (
      <div style={Object.assign({ display: "inline-block" }, style)}>
        <RaisedButton label={label} onTouchTap={this._onClick} />
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          onRequestClose={this._onClose}
          animation={PopoverAnimationVertical}
        >
          <Menu desktop={true}>
            <MenuItem
              primaryText="Download full page tickets"
              onTouchTap={() => this.download(false)}
            />
            <MenuItem
              primaryText="Download ticket-stock tickets"
              onTouchTap={() => this.download(true)}
            />
          </Menu>
        </Popover>
      </div>
    );
  }
}

export default DownloadTicketsPdfButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/download-tickets-pdf-button.jsx